import { contactConfig } from "../config/contact.config";

export function getWhatsAppNumber() {
  const { countryCode, areaCode, number } = contactConfig.whatsapp;
  return `${countryCode}${areaCode}${number}`.replace(/\D/g, "");
}

export function getWhatsAppMessage(messageOrKey) {
  const messages = contactConfig.whatsapp.messages || {};

  if (!messageOrKey) {
    return contactConfig.whatsapp.defaultMessage || messages.default || "";
  }

  return messages[messageOrKey] || messageOrKey;
}

export function getWhatsAppLink(messageOrKey) {
  const phone = getWhatsAppNumber();
  const message = getWhatsAppMessage(messageOrKey);
  const query = message ? `?text=${encodeURIComponent(message)}` : "";

  return `https://wa.me/${phone}${query}`;
}
